import React, {useEffect} from 'react';

const Redirect = ({ to }) => {
  useEffect(() => {
    if (to) {
      window.location.href = to;
    }
  }, []);
  return false;
};

export default Redirect;
